export const useDownloadFile = () => {
	const downloadFile = async (downloadPromise) => {
		try {
			const { data, headers } = await downloadPromise;

			const url = window.URL.createObjectURL(new Blob([data]));
			const link = document.createElement('a');
			link.href = url;

			let filename = 'noname';
			const filenameMatch = headers['content-disposition']?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
			if (filenameMatch && filenameMatch[1]) {
				filename = filenameMatch[1].replace(/['"]/g, '');
			}

			link.style.display = 'none';
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error;
		}
	};
	return {
		downloadFile
	};
};
